import { updateCategoryType } from '@/plugins/dataLayer/utils/index.js';

export default function($store) {
    return {
      name: 'Checkerboard',
      event: {
        name: 'trackEvent',
        nameIframe: 'loadEventData',
        category: 'Customs',
        nonInteractive: false,
        customMetrics: {},
        customVariables: {},
        _clear: true
      },
      types: {
        custom: 'custom',

      },
      labels: {
        closeModal: 'Close Modal',
        backModal: 'Back Modal',
        next: 'Next',
        cancel: 'Cancel',
        finish: 'Finish',
        createNewCheckerboard: 'Create a New Checkerboard Design',
        continueSameCheckerboard: 'Continue With This Checkerboard Design',
        confirmDesignLoaded: 'Confirmed Design Loaded'
      },
      /**
       * @function logAnalyticsEvent
       * @description Adds an event to GTM's dataLayer.
       * These events are during the randomizer workflow
       * but share the same formatting. This function is provided for the Checkerboard
       * in order to avoid code duplication in the formatting of the GTM events.
       *
       * @param {object} payload
       * MUST have type attribute, to assure the dataLayer event type.
       * CAN have action attribute for extra value added in each action event
       * MUST have eventLabel attribute, to assure the dataLayer eventLabel.
       * @returns {void}
       */
      logAnalyticsEvent: function (payload) {
        const useEcomDataLayerFormat = $store.getters['utils/useEcomDataLayerFormat'];
        const canvasActive = $store.getters["utils/canvasActive"];

        const data = {
          event: useEcomDataLayerFormat ? this.event.nameIframe : this.event.name,
          eventCategory: this.event.category,
          eventLabel: payload.eventLabel,
          eventAction: this.name
        };

        if (useEcomDataLayerFormat) {
          data.nonInteractive = this.event.nonInteractive;
          data.customMetrics = payload.customMetrics ? payload.customMetrics : this.event.customMetrics;
          data.customVariables = payload.customMetrics ? payload.customMetrics : this.event.customVariables;
          data._clear = this.event._clear;
        }

        if(payload.action){
           data.eventAction = `${ this.name } - ${payload.action}`;
        }

        try {
          if(canvasActive) parent.dataLayer.push(data);
          else dataLayer.push(data)
        } catch (err) {
          console.error("CORS origin error on datalayer push to parent", err);
        }
      },
      updateCategoryType: updateCategoryType,
    };
  };
